import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { LoginResponse } from 'api/login-model'

interface userState {
  loginInfo: LoginResponse | null
  setLoginInfo: (info: LoginResponse | null) => void
}

export default create<userState>()(
  persist(
    (setState) => ({
      loginInfo: null,
      setLoginInfo(info) {
        setState({ loginInfo: info })
      }
    }),
    { name: 'user' }
  )
)

export type { userState }
